import { IPublisher, transformPublisher } from '~/src/dash/api/console-api';
import {
  addDomainAndTokenToUrl,
  createURLWithTokenAndCustomPath,
  IHttpResponse,
  restGet,
} from '~/src/dash/api/rest';

export interface IPublishersByPartner {
  [key: string]: Array<Partial<IPublisher>>;
}

export const publisherHasCustomBidderTiers = (publisher: IPublisher): boolean => {
  if (
    publisher.BidderTier1CustomName !== '' ||
    publisher.BidderTier2CustomName !== '' ||
    publisher.BidderTier3CustomName !== '' ||
    publisher.BidderTier4CustomName !== '' ||
    publisher.BidderTier5CustomName !== '' ||
    publisher.BidderTier6CustomName !== '' ||
    publisher.BidderTier7CustomName !== '' ||
    publisher.BidderTier8CustomName !== '' ||
    publisher.BidderTier9CustomName !== '' ||
    publisher.BidderTier10CustomName !== ''
  ) {
    return true;
  }
  return false;
};

// Bidder tiers 7 - 10 do not support custom names and will return directly (HB-3071)
export const convertBidderTierToCustom = (publisher: IPublisher, bidderTier: string): string => {
  if (publisher.BidderTier1CustomName !== '' && bidderTier === '1') {
    return publisher.BidderTier1CustomName;
  } else if (publisher.BidderTier2CustomName !== '' && bidderTier === '2') {
    return publisher.BidderTier2CustomName;
  } else if (publisher.BidderTier3CustomName !== '' && bidderTier === '3') {
    return publisher.BidderTier3CustomName;
  } else if (publisher.BidderTier4CustomName !== '' && bidderTier === '4') {
    return publisher.BidderTier4CustomName;
  } else if (publisher.BidderTier5CustomName !== '' && bidderTier === '5') {
    return publisher.BidderTier5CustomName;
  } else if (publisher.BidderTier6CustomName !== '' && bidderTier === '6') {
    return publisher.BidderTier6CustomName;
  } else if (publisher.BidderTier7CustomName !== '' && bidderTier === '7') {
    return publisher.BidderTier7CustomName;
  } else if (publisher.BidderTier8CustomName !== '' && bidderTier === '8') {
    return publisher.BidderTier8CustomName;
  } else if (publisher.BidderTier9CustomName !== '' && bidderTier === '9') {
    return publisher.BidderTier9CustomName;
  } else if (publisher.BidderTier10CustomName !== '' && bidderTier === '10') {
    return publisher.BidderTier10CustomName;
  }
  return bidderTier;
};

// GET publishers list
// /publishers/simplified_v1 (only return id and name)
export async function getPublishersSimplifiedV1(): Promise<[Array<Partial<IPublisher>>?, Error?]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/simplified_v1`);
  try {
    const resp = await restGet<any>(reqUrl, {});
    const publishers = [] as Array<Partial<IPublisher>>;
    for (const publisher of resp.parsedBody) {
      const parsedPublisher = transformPublisher(publisher);
      publishers.push(parsedPublisher);
    }
    return [publishers, undefined];
  } catch (e) {
    console.error(e);
    return [undefined, e];
  }
}

// GET publishers by partners
// /publishers/byparnter
export async function getPublishersByPartner(): Promise<IPublishersByPartner> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/byparnter`);
  return await restGet<IPublishersByPartner>(reqUrl, {}).then(
    (val: IHttpResponse<IPublishersByPartner>) => {
      return val.parsedBody ? val.parsedBody : {};
    },
  );
}

export async function getPublishersByPartnerDataStore(): Promise<IPublishersByPartner> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/byparnter-data-store`);
  return await restGet<IPublishersByPartner>(reqUrl, {}).then(
    (val: IHttpResponse<IPublishersByPartner>) => {
      return val.parsedBody ? val.parsedBody : {};
    },
  );
}

export async function getPublishersByPartnerDataShare(): Promise<IPublishersByPartner> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/byparnter-data-share`);
  return await restGet<IPublishersByPartner>(reqUrl, {}).then(
    (val: IHttpResponse<IPublishersByPartner>) => {
      return val.parsedBody ? val.parsedBody : {};
    },
  );
}

export async function genPlatformMarketplacePublishersList(
  publisherID: string,
): Promise<IPublisher[]> {
  const reqUrl = createURLWithTokenAndCustomPath(
    `/publisher/${publisherID}/get_marketplace_buyers`,
  );
  return await restGet<IPublisher[]>(reqUrl, {}).then((val: IHttpResponse<IPublisher[]>) => {
    return val.parsedBody ? val.parsedBody : [];
  });
}

export enum ESupportTier {
  none = 0,
  platinum = 1,
  diamond = 2,
  gold = 3,
  silver = 4,
}

// used for general settings form
export const publisherSupportTierDisplayedItems = [
  {
    id: ESupportTier.none,
    value: ESupportTier.none,
    label: 'None',
  },
  {
    id: ESupportTier.silver,
    value: ESupportTier.silver,
    label: 'Silver',
  },
  {
    id: ESupportTier.gold,
    value: ESupportTier.gold,
    label: 'Gold',
  },
  {
    id: ESupportTier.diamond,
    value: ESupportTier.diamond,
    label: 'Diamond',
  },
  {
    id: ESupportTier.platinum,
    value: ESupportTier.platinum,
    label: 'Platinum',
  },
];
